import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import JsonLd from '@/components/base/JsonLd';
import { SITE_URL } from '@/constants';
import HeroSection from './components/HeroSection';
import CategoryGrid from './components/CategoryGrid';
import BenefitsSection from './components/BenefitsSection';
import FeatureComparison from './components/FeatureComparison';
import SEOSection from './components/SEOSection';
import CompetitorSection from './components/CompetitorSection';
import CTASection from './components/CTASection';

export default function Home() {
  return (
    <div className="min-h-screen bg-background-50">
      <Navbar />

      {/* JSON-LD Structured Data */}
      <JsonLd data={{
        '@context': 'https://schema.org',
        '@type': 'WebSite',
        name: 'HoobuySpreadsheet',
        url: SITE_URL,
        description: 'HoobuySpreadsheet 2026 – A Melhor Forma de Encontrar Produtos Premium Organizados. Descubra as melhores spreadsheets do Hoobuy com atualizações diárias, produtos virais e guias completos.',
        inLanguage: 'pt-BR',
        publisher: {
          '@type': 'Organization',
          name: 'hoobuy.beauty',
          url: SITE_URL,
          logo: {
            '@type': 'ImageObject',
            url: 'https://static.readdy.ai/image/2df560051ef0cafd8dabf8a049058ba4/879fae149d7d175a673508cd1be74143.jpeg',
          },
        },
      }} />

      <main>
        {/* Module 1: Hero */}
        <HeroSection />

        {/* Module 2: Category Grid with Images */}
        <CategoryGrid />

        {/* Module 3: Benefits & About */}
        <BenefitsSection />

        {/* Module 4: Feature Comparison Table */}
        <FeatureComparison />

        {/* Module 5: 9 SEO Articles */}
        <SEOSection />

        {/* Module 6: Competitor & Trust (Dark Section) */}
        <CompetitorSection />

        {/* Module 7: CTA Section */}
        <CTASection />
      </main>

      {/* Module 8: Footer */}
      <Footer />
    </div>
  );
}